export const URL = (s: string, host?: string) => {
  const absolute = (host ?? '') + s

  if (typeof window === 'undefined') {
    return new global.URL(absolute)
  }
  return new window.URL(absolute)

  // 보류: ie11에서 new URL이 지원안된다고 되어 있느나, 테스트 결과 먹힘
  // const el = document.createElement('a')
  // el.href = absolute
  // return el
}

export const pushState = (path: string) => {
  if (typeof window !== 'undefined') {
    const cur = URL(window.location.href).pathname
    const q = window.location.search

    if (cur !== path) {
      history.pushState(null, document.title, `${path}${q}`)
    }
  }
}
